﻿import radioButton from '@components/radioButton';
import { store, store$ } from '@redux/store';
import { distinctUntilChanged, map } from 'rxjs';
import { selectBedrooms } from '../redux/selectors';
import { searchParametersSlice } from '../redux/slices';

export default class Bedroom {
  constructor(bedroomsGroup) {
    this.bedroomsGroup = bedroomsGroup;
    const bedroomsRadio$ = radioButton(bedroomsGroup);
    bedroomsRadio$.subscribe((value) => store.dispatch(searchParametersSlice.actions.fetchBedrooms(value)));
    store$.pipe(map(selectBedrooms), distinctUntilChanged()).subscribe(this.updateValue.bind(this));
  }

  updateValue(value) {
    const bedrooms = value || 0;
    const previousValue = this.bedroomsGroup.querySelector('input:checked');
    const newValue = this.bedroomsGroup.querySelector(`[value="${bedrooms}"]`);
    if (previousValue) {
      previousValue.checked = false;
    }
    newValue.checked = true;
  }
}
